import { Category } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'
import { CategoriesQuery } from '@/features/pos/components/ProductCatalog/queries/categories'
import {
    appendContainersCategory,
    transformCategory,
} from '@/features/pos/components/ProductCatalog/utils/categories-with-products-transforms'
import { useHandleQueryErrorWithToast } from '@/features/pos/hooks/useHandleQueryErrorWithToast'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useCategories = (hasContainers: boolean): Category[] | undefined => {
    const { data, error, loading } = useQuery(CategoriesQuery)

    useHandleQueryErrorWithToast(error, loading)

    const { t } = useTranslation()

    return useMemo(() => {
        if (!data) return undefined

        const categories = data.categories.map(transformCategory)

        return appendContainersCategory(
            categories,
            t('pos.productCatalog.containers'),
            hasContainers
        )
    }, [data, hasContainers, t])
}
